import { render, staticRenderFns } from "./NotificationsModule.vue?vue&type=template&id=3033877c&scoped=true&lang=pug"
import script from "./NotificationsModule.vue?vue&type=script&lang=ts"
export * from "./NotificationsModule.vue?vue&type=script&lang=ts"
import style0 from "./NotificationsModule.vue?vue&type=style&index=0&id=3033877c&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3033877c",
  null
  
)

export default component.exports